import ShopType from "@/enum/ShopType";

const KWAIShop = {
    [ShopType.KWAI]: {
        image: "//img.alicdn.com/imgextra/i3/54458674/O1CN01DOlMUX2DwkAReHUY4_!!54458674.jpg",
        auth: `/login/selectLoginMethod?shopType=${ShopType.KWAI}`,
    },
};

export default KWAIShop;
